import React from "react"
import PropTypes from "prop-types"
// import Loadable from "@loadable/component"
// const useAudio = Loadable(() => import("../audio"))
import { useAudio } from "../audio"
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  CardMedia,
  Link,
} from "@material-ui/core"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { PlayArrow, Pause, CheckCircle } from "@material-ui/icons"

const onSelected = (target, quizNumber, idx, selected, setAnswer) => {
  const { tagName } = target
  switch (String(tagName).toLowerCase()) {
    case "svg":
    case "path":
    case "a":
    case "button":
      break
    default:
      setAnswer(quizNumber, idx === selected ? 0 : idx)
      break
  }
}

const SoundCard = ({ ans, setAnswer, idx, quizNumber, selected }) => {
  const { sound, soundURL, soundArtist, soundTitle, image, text } = ans
  const [playing, toggle] = useAudio(sound)
  return (
    <Card
      variant="outlined"
      className={`sound-card-root ${idx === selected ? "active" : ""}`}
      onClick={({ target }) =>
        onSelected(target, quizNumber, idx, selected, setAnswer)
      }
    >
      <div className="details">
        <CardContent className="content">
          <Typography className="title" component="h4" variant="h6">
            <Link target="_blank" rel="noopener noreferrer" href={soundURL}>
              {soundTitle}
            </Link>
          </Typography>
          <Typography
            className="subtitle"
            variant="subtitle2"
            color="textSecondary"
          >
            {soundArtist}
          </Typography>
        </CardContent>
        <div className="controls">
          <IconButton aria-label="play/pause" onClick={toggle}>
            {playing ? (
              <Pause fontSize="large" />
            ) : (
              <PlayArrow fontSize="large" />
            )}
          </IconButton>
        </div>
      </div>
      <CardMedia className="media" image={image} title={text}>
        {idx === selected && (
          <div className="active-icon">
            <CheckCircle />
          </div>
        )}
      </CardMedia>
    </Card>
  )
}

const TypicalCard = ({
  text,
  textURL,
  image,
  setAnswer,
  idx,
  quizNumber,
  selected,
}) => {
  return (
    <Card
      variant="outlined"
      className={`typical-card-root ${idx === selected ? "active" : ""}`}
      onClick={({ target }) =>
        onSelected(target, quizNumber, idx, selected, setAnswer)
      }
    >
      <div className="details">
        <CardContent className="content">
          <Typography className="title" component="h4" variant="h6">
            <Link target="_blank" rel="noopener noreferrer" href={textURL}>
              {text}
            </Link>
          </Typography>
        </CardContent>
      </div>
      {/* <CardMedia className="media" image={image} title={text}>
        {idx === selected && (
          <div className="active-icon">
            <CheckCircle />
          </div>
        )}
      </CardMedia> */}
      <CardMedia className="media" title={text}>
        <LazyLoadImage
          alt={text}
          src={image}
          height="100%"
          width="100%"
        />
        {idx === selected && (
          <div className="active-icon">
            <CheckCircle />
          </div>
        )}
      </CardMedia>
    </Card>
  )
}

function Quiz(props) {
  const { data = {}, quizNumber, answer: selected, setAnswer } = props
  const { question, answers = [] } = data

  return (
    <Paper className="quiz-card" variant="elevation" elevation={8}>
      <span className="number">{quizNumber}</span>
      <Paper className="question" variant="elevation">
        <Typography color="secondary" variant="h5" component="h3">
          {question.text}
        </Typography>
      </Paper>
      <div className="answers">
        <Grid container justify="center" alignItems="center" spacing={1}>
          {answers.map((ans, idx) => {
            const { text, sound, image } = ans
            return (
              <Grid key={text} item xs={12} sm={12} md={6} lg={4} xl={6}>
                {sound && (
                  <SoundCard
                    ans={ans}
                    idx={idx + 1}
                    quizNumber={quizNumber}
                    selected={selected}
                    setAnswer={setAnswer}
                  />
                )}
                {!sound && (
                  <TypicalCard
                    text={text}
                    image={image}
                    idx={idx + 1}
                    quizNumber={quizNumber}
                    selected={selected}
                    setAnswer={setAnswer}
                  />
                )}
              </Grid>
            )
          })}
        </Grid>
      </div>
    </Paper>
  )
}

Quiz.propTypes = {
  data: PropTypes.shape({
    question: PropTypes.shape({
      image: PropTypes.string,
      text: PropTypes.string,
    }),
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string,
        sound: PropTypes.string,
        soundTitle: PropTypes.string,
        soundArtist: PropTypes.string,
        soundURL: PropTypes.string,
        text: PropTypes.string,
      })
    ),
  }).isRequired,
  quizNumber: PropTypes.number.isRequired,
  setAnswer: PropTypes.func.isRequired,
  answer: PropTypes.number.isRequired,
}

export default Quiz
